import { SalesProduct } from '../../services/salesProductsApi';
import { ProductHtmlSection } from './ProductHtmlSection';

type ProductPageViewProps = {
  product: SalesProduct;
};

export function ProductPageView({ product }: ProductPageViewProps) {
  const coverStyle = product.coverImageBase64
    ? { backgroundImage: `url(${product.coverImageBase64})` }
    : undefined;

  return (
    <article className="overflow-hidden rounded-2xl border border-secondary-200 bg-white shadow-sm">
      <header
        className="relative min-h-[240px] bg-gradient-to-br from-primary-700 to-primary-900 bg-cover bg-center px-8 py-10 text-white"
        style={coverStyle}
      >
        <div className="relative z-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="flex items-end gap-4">
            {product.logoBase64 ? (
              <img
                src={product.logoBase64}
                alt={`Logo ${product.name}`}
                className="h-20 w-20 rounded-xl border border-white/30 bg-white object-contain p-2"
              />
            ) : null}
            <div>
              <p className="text-sm uppercase tracking-wide text-primary-100">Produto</p>
              <h1 className="text-3xl font-bold">{product.name}</h1>
            </div>
          </div>
        </div>
        <div className="absolute inset-0 bg-primary-950/40" />
      </header>

      <div className="space-y-8 px-8 py-8">
        {product.elevatorPitchHtml ? (
          <div
            className="rounded-xl bg-primary-50 px-5 py-4 text-lg text-primary-900 [&_p]:m-0"
            dangerouslySetInnerHTML={{ __html: product.elevatorPitchHtml }}
          />
        ) : null}

        <ProductHtmlSection title="Proposta de valor" html={product.valuePropositionHtml} />
        <ProductHtmlSection title="Resumo executivo" html={product.executiveSummaryHtml} />
        <ProductHtmlSection title="Descrição" html={product.descriptionHtml} />
        <ProductHtmlSection title="Módulos e funcionalidades" html={product.modulesAndFeaturesHtml} />
        <ProductHtmlSection title="Lista de recursos" html={product.featuresHtml} />
        <ProductHtmlSection title="ICP — Perfil ideal de cliente" html={product.icpHtml} />
        <ProductHtmlSection title="Segmentos" html={product.segmentsHtml} />
      </div>
    </article>
  );
}
